import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./components/home.vue"
import Course_d from "./components/course_d.vue"
import Login from "./components/Activity/login"
import Registration from "./components/Activity/registration"
import Edit_profile from "./components/Activity/Edit_profile"
import Review from "./components/Activity/review"
import Course_list from "./components/course_list.vue"
import My_learning from "./components/My_learning.vue"
import Search from "./components/search.vue"
import Certificate from "./components/certificate.vue"
import ForgetPassword from "./components/Activity/forgetpassword.vue"
import Reset_password from "./components/Activity/reset_password.vue"
import Change_success from "./components/Activity/change_success"
import NotFound from "./view/notFound.vue"
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/registration',
        name: 'Registration',
        component: Registration
    },
    {
        path: '/edit_profile',
        name: 'Edit_profile',
        component: Edit_profile
    },
    {
        path: '/course_list',
        name: 'Course_list',
        component: Course_list,
    },
    {
        path: '/my_learning',
        name: 'My_learning',
        component: My_learning,
    },
    {
        path: '/course_description',
        name: 'Course_d',
        component: Course_d
    },
    {
        path: '/review',
        name: 'Review',
        component: Review
    },
    {
        path: '/search',
        name: 'Search',
        component: Search
    },
    {
        path: '/forget_password',
        name: 'ForgetPassword',
        component: ForgetPassword
    },
    {
        path: '/change_success',
        name: 'Change_success',
        component: Change_success
    },
    {
        path: '/reset_password',
        name: 'Reset_password',
        component: Reset_password
    },
    {
        path: '/certificate',
        name: 'Certificate',
        component: Certificate
    },
    {
        path: '/*',
        name: 'NotFound',
        component: NotFound
    }
]
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;